import { useState, useEffect, useCallback } from "react";
import { useAlert } from "../functions/useAlert";
import { fetchClients } from "../services/clients.service";
import { Client } from "../components/client/types";

export function useClients(orgId: string) {
  const [clients, setClients] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [setAlert] = useAlert();

  const refetch = useCallback(async () => {
    setIsLoading(true);
    try {
      const response: any = await fetchClients(orgId);
      setClients(response || []);
    } catch (error: any) {
      if (error.status === 403) {
        setAlert(
          "Access Denied: You don't have permission to view clients.",
          "error",
        );
      } else if (error.status === 401) {
        setAlert("Session expired. Please login again.", "error");
      } else {
        setAlert(error.message || "Failed to load clients.", "error");
      }
      setClients([]);
    } finally {
      setIsLoading(false);
    }
  }, [orgId, setAlert]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { clients, isLoading, refetch };
}
